import React from 'react';

const MealTile = ({
  image,
  mealName,
  calories,
  badgeText = 'Healthy',
  status,
  onMenuClick,
  onClick
}) => {
  return (
    <div
      className="bg-white rounded-lg border border-[#E7E8EA] cursor-pointer min-w-[250px]"
      onClick={onClick}
    >
      {/* Image Container */}
      <div className="relative">
        <img
          src={image || '/placeholder-meal.jpg'}
          alt={mealName}
          className="w-full h-32 object-cover rounded-t-lg"
        />
        {/* Status Badge - Show before three dots menu */}
        {status && (
          <div className="absolute top-2 right-12">
            <span
              className={`inline-block text-xs font-medium px-3 py-1 rounded-full ${
                status === 'published'
                  ? 'bg-green-100 text-green-700'
                  : 'bg-yellow-100 text-yellow-700'
              }`}
            >
              {status === 'published' ? 'Published' : 'Draft'}
            </span>
          </div>
        )}
        {/* Three Dots Menu */}
        <button
          className="absolute top-2 right-2 bg-white rounded-full p-1 hover:bg-gray-100"
          onClick={(e) => {
            e.stopPropagation();
            onMenuClick?.(e);
          }}
        >
          <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
            <circle cx="12" cy="5" r="2" />
            <circle cx="12" cy="12" r="2" />
            <circle cx="12" cy="19" r="2" />
          </svg>
        </button>
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="text-base font-semibold text-gray-900 mb-1 overflow-hidden" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', minHeight: '3rem' }}>{mealName}</h3>
        <p className="text-sm text-gray-500 mb-3">
          {calories ? `${calories.toLocaleString()} kcal` : ''}
        </p>
        {/* Badge */}
        <span className="inline-block bg-indigo-100 text-indigo-700 text-xs font-medium px-3 py-1 rounded-full">
          {badgeText}
        </span>
      </div>
    </div>
  );
};

export default MealTile;
